import { createCable, fetchTokenFromHTML } from "@anycable/web"

const cable = createCable({ tokenRefresher: fetchTokenFromHTML() })

let disconnected = false

cable.on("disconnect", _event => {
  disconnected = true
  document.dispatchEvent(new Event("cable:disconnect"))
})
cable.on("connect", () => {
  document.dispatchEvent(new Event(`cable:${disconnected ? "reconnect" : "connect"}`))
  disconnected = false
})

export default cable
